module.exports = __webpack_public_path__ + "img/Bodice-Front-B8-Da-Ea.50fb2a6f.png";